import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Motherboard = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M3.669 6.335h2.333V3.67H3.669v2.666Zm2.666.667h-3a.333.333 0 0 1-.333-.334V3.335a.333.333 0 0 1 .333-.333h3a.333.333 0 0 1 .333.333v3.333a.333.333 0 0 1-.333.334Zm-2.5 5a.333.333 0 0 1-.333-.334V9.335a.333.333 0 0 1 .667 0v2.333a.333.333 0 0 1-.334.334Zm2 0a.333.333 0 0 1-.333-.334V9.335a.333.333 0 0 1 .667 0v2.333a.333.333 0 0 1-.334.334Zm3.5.333h3V3.669h-3v8.666Zm3.333.666H9.002a.333.333 0 0 1-.334-.333v-.333h-.333a.333.333 0 1 1 0-.667h.333v-1.333h-.333a.333.333 0 1 1 0-.667h.333V8.335h-.333a.333.333 0 0 1 0-.667h.333V6.335h-.333a.333.333 0 0 1 0-.667h.333V4.335h-.333a.333.333 0 0 1 0-.666h.333v-.334a.333.333 0 0 1 .334-.333h3.666a.333.333 0 0 1 .334.333v.334h.333a.333.333 0 1 1 0 .666h-.333v1.333h.333a.333.333 0 1 1 0 .667h-.333v1.333h.333a.333.333 0 1 1 0 .667h-.333v1.333h.333a.333.333 0 1 1 0 .667h-.333v1.333h.333a.333.333 0 1 1 0 .667h-.333v.333a.333.333 0 0 1-.334.334Zm-11 1.334h12.667V1.669H1.669v12.666Zm13 .666H1.335a.333.333 0 0 1-.333-.333V1.335a.333.333 0 0 1 .333-.333h13.333a.333.333 0 0 1 .334.333v13.333a.334.334 0 0 1-.334.333Z" />
    </svg>
  );
};

Motherboard.category = 'product-category';

Motherboard.displayName = 'Motherboard';
